import { addDays, differenceInDays } from "date-fns";
import { DateTime } from "luxon";

/** Luxon-based replacement for date-fns-tz `formatInTimeZone` (not a dep here). */
export function formatInTimezone(date: Date, timezone: string, format: string): string {
  return DateTime.fromJSDate(new Date(date), { zone: timezone }).setLocale("fr").toFormat(format);
}

/** Port of timezoneToParsedOffset (Vue). */
export function timezoneToParsedOffset(tz: string, date?: Date) {
  const offsetInMinutesSigned = DateTime.fromJSDate(date ?? new Date(), { zone: tz }).offset;
  const offsetInMinutes = Math.abs(offsetInMinutesSigned);
  const offsetInHours = Math.floor(offsetInMinutes / 60);

  return {
    hours: offsetInHours,
    minutes: offsetInMinutes - 60 * offsetInHours,
    sign: offsetInMinutesSigned > 0 ? "+" : "-",
  };
}

export function minTwoDigits(n: number): string {
  return (n < 10 ? "0" : "") + n;
}

/** Port of get-remaining-delay.ts (Vue). */
export function getRemainingDelayInDays(stateUpdatedAt: Date, expectedDurationInDays: number): number {
  if (!stateUpdatedAt) {
    return 2;
  }
  const lastUpdate = new Date(stateUpdatedAt);
  const expirationDate = addDays(lastUpdate, expectedDurationInDays);

  return differenceInDays(expirationDate, new Date());
}
